import { styled } from '@mui/material/styles';
import { Box, Container } from '@mui/material';

import { RegisterForm } from '../../sections/auth/register/RegisterForm';
import { Logo } from '../../components/Logo';
import { Typography } from 'components/Typography/Typography';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const Register = () => (
  <>
    <RootStyle>
      <HeaderStyle>
        <Logo />
      </HeaderStyle>

      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5, display: 'flex', alignItems: 'center' }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" gutterBottom>
                Регистрация в панели управления Kolsa
              </Typography>
            </Box>
          </Box>

          <RegisterForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  </>
);

export default Register;
